import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'model-submit',
  template: `
    <div class="dynamic-field form-button" [formGroup]="group">
        <button class="btn btn-primary" type="submit">{{map.name}}</button>
    </div>
  `,
  styles: []
})
export class SubmitComponent {
    map: any;
    group: FormGroup;

}
